/* PUVANO Warenkorb – ersetzt die App „Upcart". Benötigt assets/puvano-cart-logic.js (vorher geladen). */
(function () {
  'use strict';
  if (window.__puvanoCartDrawerLoaded) return;
  window.__puvanoCartDrawerLoaded = true;

  var L = window.PuvanoCartLogic;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var instance = null;

  var ICONS = {
    trash: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"/><path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"/><path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"/></svg>',
    minus: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M5 10c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75Z"/></svg>',
    plus: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path d="M10.75 5.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.5h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5Z"/></svg>',
    tag: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill-rule="evenodd" d="M8.575 4.649a3.75 3.75 0 0 1 2.7-1.149h1.975a3.25 3.25 0 0 1 3.25 3.25v2.187a3.25 3.25 0 0 1-.996 2.34l-4.747 4.572a2.5 2.5 0 0 1-3.502-.033l-2.898-2.898a2.75 2.75 0 0 1-.036-3.852l4.254-4.417Zm4.425 3.351a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/></svg>'
  };
  var SPINNER = '<span class="pcd-spinner" aria-hidden="true"></span>';

  /* ---------- Anbindung ans Theme: Warenkorb-Anfragen anderer Skripte erkennen ---------- */

  function cartRequestKind(url) {
    var path;
    try { path = new URL(String(url), location.href).pathname; } catch (e) { return null; }
    if (/\/cart\/add(\.js)?$/.test(path)) return 'add';
    if (/\/cart\/(change|update|clear)(\.js)?$/.test(path)) return 'change';
    return null;
  }

  function notify(kind) {
    if (instance) instance.refresh(kind === 'add');
  }

  window.fetch = function (input, init) {
    var url = input instanceof Request ? input.url : String(input);
    var kind = cartRequestKind(url);
    var promise = nativeFetch(input, init);
    if (kind) promise.then(function (res) {
      if (res.ok) notify(kind);
      else if (kind === 'add' && instance) instance.refresh(false); // z. B. Teilmenge wegen Lagerbestand
    }, function () {});
    return promise;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__pcdKind = cartRequestKind(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__pcdKind) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) notify(xhr.__pcdKind);
      });
    }
    return xhrSend.apply(this, arguments);
  };

  // Warenkorb-Symbol im Header öffnet unseren Drawer (Capture-Phase: vor dem Theme)
  document.addEventListener('click', function (e) {
    if (!instance || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var trigger = e.target.closest && e.target.closest('#cart-icon-bubble, a[href="' + ROOT + 'cart"]');
    if (!trigger || instance.contains(trigger)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    instance.open();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!instance) return;
    if (e.key === ' ' && e.target.closest && e.target.closest('#cart-icon-bubble')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      instance.open();
      return;
    }
    if (!instance.isOpen) return;
    if (e.key === 'Escape') instance.close();
    else if (e.key === 'Tab') instance.trapFocus(e);
  }, true);

  // Theme-Editor: Drawer beim Auswählen der Section/eines Blocks öffnen
  function editorTarget(e) { return instance && e.detail && e.detail.sectionId === instance.dataset.sectionId; }
  document.addEventListener('shopify:section:select', function (e) { if (editorTarget(e)) instance.open(); });
  document.addEventListener('shopify:block:select', function (e) { if (editorTarget(e)) instance.open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (editorTarget(e)) instance.close(); });

  // Zurück-Button (bfcache): Warenkorb kann sich inzwischen geändert haben, z. B. nach dem Checkout
  window.addEventListener('pageshow', function (e) { if (e.persisted && instance) instance.refresh(false); });

  /* ---------- Custom Element ---------- */

  class PuvanoCartDrawer extends HTMLElement {
    connectedCallback() {
      // Direkt unter <body> hängen: Transforms der Section-Wrapper würden position:fixed sonst verschieben.
      // Ein nach Editor-Neuladen übrig gebliebenes altes Element wird dabei entfernt.
      if (this.parentElement !== document.body) {
        Array.prototype.forEach.call(document.querySelectorAll('body > puvano-cart-drawer'), function (old) { old.remove(); });
        document.body.appendChild(this);
        return;
      }
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-pcd-config]').textContent);
      this.panel = this.querySelector('.pcd-panel');
      this.el = {
        title: this.querySelector('[data-pcd-title]'),
        error: this.querySelector('[data-pcd-error]'),
        rewards: this.querySelector('[data-pcd-rewards]'),
        items: this.querySelector('[data-pcd-items]'),
        upsells: this.querySelector('[data-pcd-upsells]'),
        track: this.querySelector('[data-pcd-track]'),
        prev: this.querySelector('[data-pcd-prev]'),
        next: this.querySelector('[data-pcd-next]'),
        discounts: this.querySelector('[data-pcd-discounts]'),
        checkout: this.querySelector('[data-pcd-checkout]')
      };
      this.compareAt = new Map();
      var known = this.config.compareAt || {};
      Object.keys(known).forEach(function (id) { this.compareAt.set(String(id), Number(known[id]) || 0); }, this);
      this.productRequests = new Map();
      this.recRequests = new Map();
      this.upsellProducts = new Map();
      this.pending = new Map(); // Line-Item-Key → {quantity, action} für noch laufende Änderungen
      this.queue = Promise.resolve();
      this.slide = 0;
      this.upsellKey = null;
      this.upsellToken = 0;
      this.isOpen = false;
      this.cart = this.config.cart;

      this.buildBar();
      this.bindEvents();
      this.render();

      instance = this;
      var self = this;
      window.PuvanoCart = {
        open: function () { self.open(); },
        close: function () { self.close(); },
        refresh: function () { return self.refresh(false); }
      };
      // Erst jetzt den Theme-Drawer ausblenden: Scheitert der Start, bleibt der Theme-Warenkorb nutzbar.
      document.documentElement.classList.add('pcd-ready');
      if (this.inEditor() && window.__pcdEditorOpen) this.open();
    }

    disconnectedCallback() {
      if (instance !== this) return;
      instance = null;
      document.documentElement.classList.remove('pcd-lock', 'pcd-ready');
    }

    inEditor() { return !!(window.Shopify && window.Shopify.designMode); }
    money(cents) { return L.formatMoney(cents, this.config.moneyFormat); }
    dispatch(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }

    /* ----- Öffnen / Schließen ----- */

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.classList.add('is-open');
      document.documentElement.classList.add('pcd-lock');
      this.releaseNativeDrawer();
      var self = this;
      setTimeout(function () { self.releaseNativeDrawer(); }, 400);
      this.panel.focus({ preventScroll: true });
      if (this.inEditor()) window.__pcdEditorOpen = true;
      this.dispatch('puvano:cart:opened');
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('pcd-lock');
      this.releaseNativeDrawer();
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      if (this.inEditor()) window.__pcdEditorOpen = false;
      this.dispatch('puvano:cart:closed');
    }

    // Das Theme öffnet nach „In den Warenkorb" seinen (ausgeblendeten) Drawer und sperrt das Scrollen – rückgängig machen.
    releaseNativeDrawer() {
      var native = document.querySelector('cart-drawer');
      if (native) native.classList.remove('active', 'animate');
      document.body.classList.remove('overflow-hidden');
    }

    trapFocus(e) {
      var focusables = Array.prototype.filter.call(
        this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || active === this.panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    }

    /* ----- Ereignisse im Drawer ----- */

    bindEvents() {
      var self = this;
      this.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-pcd-close]')) { e.preventDefault(); self.close(); return; }
        var li = t.closest('.pcd-item');
        if (li) {
          var qty = Number(li.dataset.qty);
          if (t.closest('[data-pcd-plus]')) { self.changeItem(li, qty + 1, 'plus'); return; }
          if (t.closest('[data-pcd-minus]')) { self.changeItem(li, Math.max(0, qty - 1), 'minus'); return; }
          if (t.closest('[data-pcd-remove]')) { self.changeItem(li, 0, 'remove'); return; }
        }
        if (t.closest('[data-pcd-prev]')) { self.goTo(self.slide - 1); return; }
        if (t.closest('[data-pcd-next]')) { self.goTo(self.slide + 1); return; }
        var add = t.closest('[data-pcd-add]');
        if (add) self.addUpsell(add);
      });
      this.addEventListener('change', function (e) {
        var input = e.target.closest('.pcd-qty input');
        if (input) {
          var li = input.closest('.pcd-item');
          var value = parseInt(input.value, 10);
          if (isNaN(value) || value < 0) { input.value = li.dataset.qty; return; }
          if (value !== Number(li.dataset.qty)) self.changeItem(li, value, 'input');
          return;
        }
        var select = e.target.closest('.pcd-upsell select');
        if (select) self.updateUpsellPrice(select);
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('.pcd-qty input')) e.target.blur();
      });
    }

    /* ----- Netzwerk ----- */

    enqueue(task) {
      var run = this.queue.then(task, task);
      this.queue = run.catch(function () {});
      return run;
    }

    async api(path, body) {
      var res = await nativeFetch(ROOT + path, body
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
        : { headers: { Accept: 'application/json' } });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok) throw new Error(data.description || data.message || 'Der Warenkorb konnte nicht aktualisiert werden.');
      return data;
    }

    async loadCart() {
      var cart = await this.api('cart.js');
      await this.ensureCompareAt(cart);
      this.setCart(cart);
    }

    refresh(openAfter) {
      var self = this;
      return this.enqueue(function () {
        return self.loadCart().then(function () { self.updateBubble(); });
      }).then(
        function () { if (openAfter) self.open(); },
        function (err) { console.error('[PUVANO Warenkorb]', err); if (openAfter) self.open(); }
      );
    }

    setCart(cart) {
      this.cart = cart;
      this.render();
      this.dispatch('puvano:cart:updated', { cart: cart });
    }

    async ensureCompareAt(cart) {
      var self = this, handles = [];
      cart.items.forEach(function (item) {
        if (!self.compareAt.has(String(item.variant_id)) && handles.indexOf(item.handle) === -1) handles.push(item.handle);
      });
      await Promise.all(handles.map(function (h) { return self.loadProduct(h); }));
    }

    loadProduct(handle) {
      var self = this;
      if (!this.productRequests.has(handle)) {
        this.productRequests.set(handle, nativeFetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) { if (product) self.rememberCompareAt(product); })
          .catch(function () {}));
      }
      return this.productRequests.get(handle);
    }

    rememberCompareAt(product) {
      (product.variants || []).forEach(function (v) { this.compareAt.set(String(v.id), Number(v.compare_at_price) || 0); }, this);
    }

    loadRecommendations(productId) {
      var self = this, limit = (this.config.upsells && this.config.upsells.perProduct) || 8;
      if (!this.recRequests.has(productId)) {
        this.recRequests.set(productId, nativeFetch(ROOT + 'recommendations/products.json?product_id=' + productId + '&intent=related&limit=' + limit)
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (data) {
            var products = data.products || [];
            products.forEach(function (p) { self.rememberCompareAt(p); });
            return products;
          })
          .catch(function () { return []; }));
      }
      return this.recRequests.get(productId);
    }

    async updateBubble(sections) {
      try {
        if (!sections) sections = await nativeFetch(ROOT + '?sections=cart-icon-bubble').then(function (r) { return r.json(); });
        var html = sections && sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        var section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      } catch (e) { /* Symbol-Zahl ist nicht kritisch */ }
    }

    showError(message) {
      var el = this.el.error;
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
      clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(function () { el.hidden = true; }, 4000);
    }

    /* ----- Aktionen ----- */

    changeItem(li, quantity, action) {
      var self = this, key = li.dataset.key;
      if (this.pending.has(key)) return;
      this.pending.set(key, { quantity: quantity, action: action });
      this.markBusy(li, action);
      return this.enqueue(async function () {
        try {
          var cart = await self.api('cart/change.js', { id: key, quantity: quantity, sections: 'cart-icon-bubble' });
          await self.ensureCompareAt(cart);
          self.pending.delete(key);
          self.setCart(cart);
          self.updateBubble(cart.sections);
        } catch (err) {
          self.pending.delete(key);
          self.showError(err.message);
          await self.loadCart().catch(function () { self.render(); });
        }
      });
    }

    // Sperrt eine Zeile während ihrer Änderung; wird nach jedem Neuaufbau der Liste erneut angewendet.
    markBusy(li, action) {
      Array.prototype.forEach.call(li.querySelectorAll('button, input'), function (el) { el.disabled = true; });
      var selector = { plus: '[data-pcd-plus]', minus: '[data-pcd-minus]', remove: '[data-pcd-remove]' }[action];
      var btn = selector && li.querySelector(selector);
      if (btn) btn.innerHTML = SPINNER;
    }

    addUpsell(btn) {
      var self = this;
      var tile = btn.closest('.pcd-upsell');
      var select = tile.querySelector('select');
      var id = Number(select ? select.value : tile.dataset.variantId);
      btn.disabled = true;
      btn.innerHTML = SPINNER;
      return this.enqueue(async function () {
        try {
          await self.api('cart/add.js', { items: [{ id: id, quantity: 1 }] });
          await self.loadCart();
          self.updateBubble();
        } catch (err) {
          self.showError(err.message);
          btn.disabled = false;
          btn.textContent = self.config.upsells.buttonText;
        }
      });
    }

    /* ----- Darstellung ----- */

    render() {
      var cart = this.cart || { items: [], item_count: 0, total_price: 0, total_discount: 0 };
      var count = cart.item_count;
      this.toggleAttribute('data-empty', count === 0);
      if (this.el.title) this.el.title.textContent = (this.config.titleText || '').replace(/\{count\}/g, count);
      this.renderRewards(count);
      this.renderItems(cart);
      this.renderDiscounts(cart);
      this.renderCheckout(cart);
      this.renderUpsells(cart);
    }

    buildBar() {
      if (!this.el.rewards) return;
      var tiers = L.computeRewards(0, this.config.tiers).tiers;
      var n = tiers.length;
      var bar = this.el.rewards.querySelector('[data-pcd-bar]');
      if (!n) { this.el.rewards.classList.add('pcd-is-hidden'); return; }
      var basis = 'calc(' + (100 / n) + '% - ' + (6 * (n - 1) / n) + 'px)';
      bar.innerHTML = tiers.map(function (t) {
        return '<div class="pcd-bar__segment" style="flex:0 0 ' + basis + '">' +
          '<div class="pcd-bar__fill"></div>' +
          '<div class="pcd-bar__milestone"><div class="pcd-bar__icon">' + ICONS.tag + '</div>' +
          '<div class="pcd-bar__label">' + L.esc(t.label) + '</div></div></div>';
      }).join('');
      this.segments = Array.prototype.map.call(bar.children, function (seg) {
        return { fill: seg.querySelector('.pcd-bar__fill'), icon: seg.querySelector('.pcd-bar__icon') };
      });
    }

    renderRewards(count) {
      if (!this.el.rewards || !this.segments) return;
      var r = L.computeRewards(count, this.config.tiers);
      this.el.rewards.querySelector('[data-pcd-rewards-msg]').textContent =
        L.rewardsMessage(r, this.config.rewards ? this.config.rewards.maxText : '');
      this.segments.forEach(function (s, i) {
        s.fill.style.width = r.fills[i] + '%';
        s.icon.classList.toggle('is-complete', !!r.completed[i]);
      });
    }

    renderItems(cart) {
      if (!this.el.items) return;
      var self = this, cfg = this.config.items || {};
      this.el.items.innerHTML = cart.items.map(function (item) {
        var compare = (self.compareAt.get(String(item.variant_id)) || 0) * item.quantity;
        var price = item.original_line_price;
        var hasCompare = compare > price;
        var title = L.esc(item.product_title);
        var url = L.esc(item.url);
        var variant = L.variantText(item);
        var props = L.visibleProperties(item);
        var image = item.image
          ? '<img src="' + L.esc(L.sizedImage(item.image, 176)) + '" alt="' + title + '" width="88" height="88" loading="lazy">'
          : '';
        return '<li class="pcd-item" data-key="' + L.esc(item.key) + '" data-qty="' + item.quantity + '">' +
          '<div class="pcd-item__content">' +
            '<a class="pcd-item__image" href="' + url + '" tabindex="-1">' + image + '</a>' +
            '<div class="pcd-item__info">' +
              '<div class="pcd-item__header">' +
                '<h4 class="pcd-item__title"><a href="' + url + '">' + title + '</a></h4>' +
                '<button type="button" class="pcd-item__remove" data-pcd-remove aria-label="' + title + ' entfernen">' + ICONS.trash + '</button>' +
              '</div>' +
              (variant ? '<div class="pcd-item__variant">' + L.esc(variant) + '</div>' : '') +
              (props.length ? '<div class="pcd-item__props">' + props.map(function (p) { return L.esc(p[0] + ': ' + p[1]); }).join('<br>') + '</div>' : '') +
              '<div class="pcd-item__pricing">' +
                (cfg.showCompare && hasCompare ? '<span class="pcd-item__compare">' + L.esc(self.money(compare)) + '</span>' : '') +
                '<span class="pcd-item__price">' + L.esc(self.money(price)) + '</span>' +
                (cfg.showSavings && hasCompare ? '<span class="pcd-item__savings">(' + L.esc(self.config.savingsText || '') + ' ' + L.esc(self.money(compare - price)) + ')</span>' : '') +
              '</div>' +
              '<div class="pcd-qty">' +
                '<button type="button" data-pcd-minus aria-label="Menge verringern">' + ICONS.minus + '</button>' +
                '<input type="text" inputmode="numeric" pattern="[0-9]*" aria-label="Menge" value="' + item.quantity + '">' +
                '<button type="button" data-pcd-plus aria-label="Menge erhöhen">' + ICONS.plus + '</button>' +
              '</div>' +
            '</div>' +
          '</div></li>';
      }).join('');
      Array.prototype.forEach.call(this.el.items.children, function (li) {
        var p = self.pending.get(li.dataset.key);
        if (p) self.markBusy(li, p.action);
      });
    }

    renderDiscounts(cart) {
      var el = this.el.discounts;
      if (!el) return;
      var d = L.groupDiscounts(cart);
      if (!d.total) { el.classList.add('pcd-is-hidden'); el.innerHTML = ''; return; }
      el.classList.remove('pcd-is-hidden');
      el.innerHTML =
        '<div class="pcd-summary__codes"><span class="pcd-summary__label">' + L.esc(this.config.discountsLabel || '') + '</span>' +
        '<div class="pcd-summary__tags">' + d.titles.map(function (t) {
          return '<span class="pcd-tag"><span class="pcd-tag__icon">' + ICONS.tag + '</span><span class="pcd-tag__text">' + L.esc(t) + '</span></span>';
        }).join('') + '</div></div>' +
        '<span class="pcd-summary__total">- ' + L.esc(this.money(d.total)) + '</span>';
    }

    renderCheckout(cart) {
      var el = this.el.checkout;
      if (!el || this.config.checkoutText == null) return;
      el.textContent = this.config.checkoutText.replace(/\{total\}/g, this.money(cart.total_price));
      el.href = ROOT + 'checkout';
    }

    renderUpsells(cart) {
      var self = this, cfg = this.config.upsells;
      if (!this.el.upsells || !cfg) return;
      var key = cart.items.map(function (i) { return i.variant_id; }).join(',');
      if (key === this.upsellKey) return;
      this.upsellKey = key;
      var token = ++this.upsellToken;
      if (!cart.items.length) { this.el.upsells.classList.add('pcd-is-hidden'); return; }
      if (!this.el.track.children.length) this.showUpsellSkeleton();
      var productIds = [];
      cart.items.forEach(function (i) { if (productIds.indexOf(i.product_id) === -1) productIds.push(i.product_id); });
      Promise.all(productIds.map(function (id) { return self.loadRecommendations(id); })).then(function (lists) {
        if (token !== self.upsellToken) return;
        var products = L.mergeRecommendations(lists, productIds, cfg.max)
          .filter(function (p) { return p.variants && p.variants.length; });
        self.paintUpsells(products, cart);
      });
    }

    showUpsellSkeleton() {
      this.el.upsells.classList.remove('pcd-is-hidden');
      this.el.track.innerHTML =
        '<div class="pcd-slide"><div class="pcd-upsell pcd-upsell--skeleton">' +
          '<div class="pcd-shimmer pcd-shimmer--image"></div>' +
          '<div class="pcd-upsell__info"><div class="pcd-shimmer pcd-shimmer--line"></div>' +
          '<div class="pcd-shimmer pcd-shimmer--line pcd-shimmer--short"></div>' +
          '<div class="pcd-shimmer pcd-shimmer--row"></div></div>' +
        '</div></div>';
    }

    paintUpsells(products, cart) {
      var self = this;
      this.upsellProducts = new Map();
      if (!products.length) {
        this.el.track.innerHTML = '';
        this.el.upsells.classList.add('pcd-is-hidden');
        return;
      }
      this.el.upsells.classList.remove('pcd-is-hidden');
      this.el.track.innerHTML = products.map(function (p, i) {
        self.upsellProducts.set(String(p.id), p);
        return self.upsellSlide(p, i, products.length, cart);
      }).join('');
      this.goTo(Math.min(this.slide, products.length - 1));
    }

    upsellSlide(p, index, total, cart) {
      var cfg = this.config.upsells;
      var v = L.pickVariant(p, cart.items, cfg.smartVariants);
      var title = L.esc(p.title), url = L.esc(p.url);
      var single = p.variants.length === 1;
      var select = single ? '' :
        '<select aria-label="Variante wählen: ' + title + '">' + p.variants.map(function (x) {
          return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' +
            L.esc(x.public_title || x.title) + '</option>';
        }).join('') + '</select>';
      var image = p.featured_image
        ? '<img src="' + L.esc(L.sizedImage(p.featured_image, 180)) + '" alt="' + title + '" width="90" height="90" loading="lazy">'
        : '';
      return '<div class="pcd-slide" role="group" aria-roledescription="slide" aria-label="' + (index + 1) + ' von ' + total + '">' +
        '<div class="pcd-upsell" data-product-id="' + p.id + '" data-variant-id="' + v.id + '">' +
          '<a class="pcd-upsell__image" href="' + url + '" aria-label="' + title + '" tabindex="-1">' + image + '</a>' +
          '<div class="pcd-upsell__info">' +
            '<a class="pcd-upsell__title-link" href="' + url + '"><h3 class="pcd-upsell__title">' + title + '</h3></a>' +
            '<div class="pcd-upsell__prices">' + this.upsellPrices(v) + '</div>' +
            '<div class="pcd-upsell__row">' + select +
              '<button type="button" class="pcd-button pcd-upsell__add" data-pcd-add>' + L.esc(cfg.buttonText) + '</button>' +
            '</div>' +
          '</div>' +
        '</div></div>';
    }

    upsellPrices(variant) {
      var compare = Number(variant.compare_at_price) || 0;
      return (compare > variant.price ? '<span class="pcd-upsell__compare">' + L.esc(this.money(compare)) + '</span>' : '') +
        '<span class="pcd-upsell__price">' + L.esc(this.money(variant.price)) + '</span>';
    }

    updateUpsellPrice(select) {
      var tile = select.closest('.pcd-upsell');
      var product = this.upsellProducts.get(tile.dataset.productId);
      if (!product) return;
      var variant = product.variants.filter(function (v) { return String(v.id) === select.value; })[0];
      if (!variant) return;
      tile.dataset.variantId = variant.id;
      tile.querySelector('.pcd-upsell__prices').innerHTML = this.upsellPrices(variant);
    }

    goTo(index) {
      if (!this.el.track) return;
      var total = this.el.track.children.length;
      this.slide = Math.max(0, Math.min(index, total - 1));
      this.el.track.style.transform = 'translateX(-' + (this.slide * 100) + '%)';
      if (this.el.prev) this.el.prev.disabled = this.slide <= 0;
      if (this.el.next) this.el.next.disabled = this.slide >= total - 1;
    }
  }

  customElements.define('puvano-cart-drawer', PuvanoCartDrawer);
})();
